export const events = {
    myLifeTitleOpened: 'mylifetitleisclosed',
}